"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getTypeLabel = exports.TYPE_LABELS = void 0;

var _react = _interopRequireDefault(require("react"));

var _clusterIcon = _interopRequireDefault(require("../assets/cluster-icon.svg"));

var _serviceAreaIcon = _interopRequireDefault(require("../assets/service-area-icon.svg"));

var _BlueCircle = _interopRequireDefault(require("../assets/BlueCircle.svg"));

var _GreenPentagon = _interopRequireDefault(require("../assets/GreenPentagon.svg"));

var _PurpleTriangle = _interopRequireDefault(require("../assets/PurpleTriangle.svg"));

var _RedDiamond = _interopRequireDefault(require("../assets/RedDiamond.svg"));

var _YellowHexagon = _interopRequireDefault(require("../assets/YellowHexagon.svg"));

var _ThematicBlue = _interopRequireDefault(require("../assets/ThematicBlue.svg"));

var _managedBadge = _interopRequireDefault(require("../assets/managed-badge.svg"));

var _criticalBadge = _interopRequireDefault(require("../assets/critical-badge.svg"));

var _bothBadge = _interopRequireDefault(require("../assets/both-badge.svg"));

var _bothTf = _interopRequireDefault(require("../assets/both-tf.svg"));

var _clusterTf = _interopRequireDefault(require("../assets/cluster-tf.svg"));

var _criticalTf = _interopRequireDefault(require("../assets/critical-tf.svg"));

var _managedTf = _interopRequireDefault(require("../assets/managed-tf.svg"));

var _infoboxConfig = _interopRequireWildcard(require("./infoboxConfig"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TYPE_LABELS = {
  BOTH: 'Both Accounts Affected',
  JOC: 'Critical Accounts Affected',
  LCS: 'Managed Accounts Affected',
  REGULAR: 'Customers Affected'
};
exports.TYPE_LABELS = TYPE_LABELS;

var getTypeLabel = function getTypeLabel(type) {
  return TYPE_LABELS[type] || TYPE_LABELS.REGULAR;
};

exports.getTypeLabel = getTypeLabel;
var outageLayer = {
  layerName: 'outages',
  layerLabel: 'Outages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/all_outages/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return outage.desc.cluster ? 'AREA OUTAGES' : 'OUTAGE INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.default,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: [1, 50],
    label: '1 - 50',
    icon: {
      url: _BlueCircle.default
    },
    shape: {
      fillColor: '#06a1d6'
    }
  }, {
    range: [51, 500],
    label: '51 - 500',
    icon: {
      url: _GreenPentagon.default
    },
    shape: {
      fillColor: '#5f8c3d'
    }
  }, {
    range: [501, 1000],
    label: '501 - 1000',
    icon: {
      url: _YellowHexagon.default
    },
    shape: {
      fillColor: '#fdcb25'
    }
  }, {
    range: [1001, 2500],
    label: '1001 - 2500',
    icon: {
      url: _RedDiamond.default
    },
    shape: {
      fillColor: '#ff190c'
    }
  }, {
    range: [2501],
    label: '> 2500',
    icon: {
      url: _PurpleTriangle.default
    },
    shape: {
      fillColor: '#662d91'
    }
  }, {
    range: 'cluster',
    label: 'Multiple Outages',
    icon: {
      url: _clusterIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.JOC,
    icon: {
      url: _criticalBadge.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.LCS,
    icon: {
      url: _managedBadge.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.BOTH,
    icon: {
      url: _bothBadge.default
    },
    shape: null
  }]
};
var outageLayerLite = {
  layerName: 'outages_lite',
  layerLabel: 'Outages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/filtered_all_outages/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return outage.desc.cluster ? 'AREA OUTAGES' : 'OUTAGE INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.default,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: [1, 50],
    label: '1 - 50',
    icon: {
      url: _BlueCircle.default
    },
    shape: {
      fillColor: '#06a1d6'
    }
  }, {
    range: [51, 500],
    label: '51 - 500',
    icon: {
      url: _GreenPentagon.default
    },
    shape: {
      fillColor: '#5f8c3d'
    }
  }, {
    range: [501, 1000],
    label: '501 - 1000',
    icon: {
      url: _YellowHexagon.default
    },
    shape: {
      fillColor: '#fdcb25'
    }
  }, {
    range: [1001, 2500],
    label: '1001 - 2500',
    icon: {
      url: _RedDiamond.default
    },
    shape: {
      fillColor: '#ff190c'
    }
  }, {
    range: [2501],
    label: '2501+',
    icon: {
      url: _PurpleTriangle.default
    },
    shape: {
      fillColor: '#662d91'
    }
  }, {
    range: 'cluster',
    label: 'Multiple Outages',
    icon: {
      url: _clusterIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.JOC,
    icon: {
      url: _criticalBadge.default
    },
    shape: null
  }]
};
var regularOutageLayer = {
  layerName: 'regular_outages',
  layerLabel: 'Regular Outages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/regular_outages/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return outage.desc.cluster ? 'AREA OUTAGES' : 'OUTAGE INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.default,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: [1, 50],
    label: '1 - 50',
    icon: {
      url: _BlueCircle.default
    },
    shape: {
      fillColor: '#06a1d6'
    }
  }, {
    range: [51, 500],
    label: '51 - 500',
    icon: {
      url: _GreenPentagon.default
    },
    shape: {
      fillColor: '#5f8c3d'
    }
  }, {
    range: [501, 1000],
    label: '501 - 1000',
    icon: {
      url: _YellowHexagon.default
    },
    shape: {
      fillColor: '#fdcb25'
    }
  }, {
    range: [1001, 2500],
    label: '1001 - 2500',
    icon: {
      url: _RedDiamond.default
    },
    shape: {
      fillColor: '#ff190c'
    }
  }, {
    range: [2501],
    label: '2501+',
    icon: {
      url: _PurpleTriangle.default
    },
    shape: {
      fillColor: '#662d91'
    }
  }, {
    range: 'cluster',
    label: 'Multiple Outages',
    icon: {
      url: _clusterIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }]
};
var criticalOutageLayer = {
  layerName: 'critical_outages',
  layerLabel: 'Critical Outages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/critical_outages/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return outage.desc.cluster ? 'AREA OUTAGES' : 'OUTAGE INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.default,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: [1, 50],
    label: '1 - 50',
    icon: {
      url: _BlueCircle.default
    },
    shape: {
      fillColor: '#06a1d6'
    }
  }, {
    range: [51, 500],
    label: '51 - 500',
    icon: {
      url: _GreenPentagon.default
    },
    shape: {
      fillColor: '#5f8c3d'
    }
  }, {
    range: [501, 1000],
    label: '501 - 1000',
    icon: {
      url: _YellowHexagon.default
    },
    shape: {
      fillColor: '#fdcb25'
    }
  }, {
    range: [1001, 2500],
    label: '1001 - 2500',
    icon: {
      url: _RedDiamond.default
    },
    shape: {
      fillColor: '#ff190c'
    }
  }, {
    range: [2501],
    label: '2501+',
    icon: {
      url: _PurpleTriangle.default
    },
    shape: {
      fillColor: '#662d91'
    }
  }, {
    range: 'cluster',
    label: 'Multiple Outages',
    icon: {
      url: _clusterIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.JOC,
    icon: {
      url: _criticalBadge.default
    },
    shape: null
  }]
};
var managedOutageLayer = {
  layerName: 'managed_outages',
  layerLabel: 'Managed Outages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/managed_outages/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return outage.desc.cluster ? 'AREA OUTAGES' : 'OUTAGE INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.default,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: [1, 50],
    label: '1 - 50',
    icon: {
      url: _BlueCircle.default
    },
    shape: {
      fillColor: '#06a1d6'
    }
  }, {
    range: [51, 500],
    label: '51 - 500',
    icon: {
      url: _GreenPentagon.default
    },
    shape: {
      fillColor: '#5f8c3d'
    }
  }, {
    range: [501, 1000],
    label: '501 - 1000',
    icon: {
      url: _YellowHexagon.default
    },
    shape: {
      fillColor: '#fdcb25'
    }
  }, {
    range: [1001, 2500],
    label: '1001 - 2500',
    icon: {
      url: _RedDiamond.default
    },
    shape: {
      fillColor: '#ff190c'
    }
  }, {
    range: [2501],
    label: '2501+',
    icon: {
      url: _PurpleTriangle.default
    },
    shape: {
      fillColor: '#662d91'
    }
  }, {
    range: 'cluster',
    label: 'Multiple Outages',
    icon: {
      url: _clusterIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.LCS,
    icon: {
      url: _managedBadge.default
    },
    shape: null
  }]
};
var bothOutageLayer = {
  layerName: 'both_outages',
  layerLabel: 'Both Outages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/both_outages/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return outage.desc.cluster ? 'AREA OUTAGES' : 'OUTAGE INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.default,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: [1, 50],
    label: '1 - 50',
    icon: {
      url: _BlueCircle.default
    },
    shape: {
      fillColor: '#06a1d6'
    }
  }, {
    range: [51, 500],
    label: '51 - 500',
    icon: {
      url: _GreenPentagon.default
    },
    shape: {
      fillColor: '#5f8c3d'
    }
  }, {
    range: [501, 1000],
    label: '501 - 1000',
    icon: {
      url: _YellowHexagon.default
    },
    shape: {
      fillColor: '#fdcb25'
    }
  }, {
    range: [1001, 2500],
    label: '1001 - 2500',
    icon: {
      url: _RedDiamond.default
    },
    shape: {
      fillColor: '#ff190c'
    }
  }, {
    range: [2501],
    label: '2501+',
    icon: {
      url: _PurpleTriangle.default
    },
    shape: {
      fillColor: '#662d91'
    }
  }, {
    range: 'cluster',
    label: 'Multiple Outages',
    icon: {
      url: _clusterIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }, {
    range: undefined,
    label: TYPE_LABELS.BOTH,
    icon: {
      url: _bothBadge.default
    },
    shape: null
  }]
};
var bothTFLayer = {
  layerName: 'both_tf',
  layerLabel: 'Both Transformers',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/transformer_BOTH/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod() {
    return 'TRANSFORMER INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.infoBoxBodyTF,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: 'JOC',
    label: TYPE_LABELS.JOC,
    icon: {
      url: _criticalTf.default
    },
    shape: null
  }, {
    range: 'LCS',
    label: TYPE_LABELS.LCS,
    icon: {
      url: _managedTf.default
    },
    shape: null
  }, {
    range: 'BOTH',
    label: TYPE_LABELS.BOTH,
    icon: {
      url: _bothTf.default
    },
    shape: null
  }, {
    range: 'cluster',
    label: 'Multiple Transformers',
    icon: {
      url: _clusterTf.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }]
};
var criticalTF = {
  layerName: 'critical_tf',
  layerLabel: 'Critical Transformers',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/transformer_critical/{q}.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: false,
  infoboxTitleMethod: function infoboxTitleMethod() {
    return 'TRANSFORMER INFORMATION';
  },
  infoboxBodyMethod: _infoboxConfig.infoBoxBodyTF,
  infoboxFooterMethod: _infoboxConfig.infoboxFooter,
  layerRangeStyle: [{
    range: 'JOC',
    label: TYPE_LABELS.JOC,
    icon: {
      url: _criticalTf.default
    },
    shape: null
  }, {
    range: 'cluster',
    label: 'Multiple Transformers',
    icon: {
      url: _clusterTf.default
    },
    shape: null
  }, {
    range: undefined,
    label: 'Service Area',
    icon: {
      url: _serviceAreaIcon.default
    },
    shape: null
  }]
};
var countyLayer = {
  layerName: 'thematic_county',
  layerLabel: 'County',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/thematic_county/thematic_areas.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: true,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return "".concat(outage.desc.title, " COUNTY");
  },
  infoboxBodyMethod: _infoboxConfig.countyInfoBoxBody,
  infoboxFooterMethod: _infoboxConfig.infoboxFooterThematic,
  layerRangeStyle: [{
    range: [1],
    label: 'Affected Counties',
    icon: {
      url: _ThematicBlue.default
    },
    shape: {
      fillColor: '#06a1d6',
      borderColor: '#000'
    }
  }]
};
var zipLayer = {
  layerName: 'thematic_zip',
  layerLabel: 'Zip',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/thematic_zip/thematic_areas.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: true,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return "ZIP CODE ".concat(outage.desc.title);
  },
  infoboxBodyMethod: _infoboxConfig.countyInfoBoxBody,
  infoboxFooterMethod: _infoboxConfig.infoboxFooterThematic,
  layerRangeStyle: [{
    range: [1],
    label: 'Affected Zip Codes',
    icon: {
      url: _ThematicBlue.default
    },
    shape: {
      fillColor: '#06a1d6',
      borderColor: '#000'
    }
  }]
};
var wardsLayer = {
  layerName: 'thematic_wards',
  layerLabel: 'Town-Ward',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/thematic_wards/thematic_areas.json");
  },
  hideInfobox: false,
  zIndexMarker: 1000,
  zIndexShape: 100,
  ignoreMarker: false,
  ignoreShape: true,
  infoboxTitleMethod: function infoboxTitleMethod(outage) {
    return "".concat(outage.desc.title);
  },
  infoboxBodyMethod: _infoboxConfig.countyInfoBoxBody,
  infoboxFooterMethod: _infoboxConfig.infoboxFooterThematic,
  layerRangeStyle: [{
    range: [1],
    label: 'Affected Towns, Villages, and Wards',
    icon: {
      url: _ThematicBlue.default
    },
    shape: {
      fillColor: '#06a1d6',
      borderColor: '#000'
    }
  }]
};
var layers = [outageLayer, outageLayerLite, regularOutageLayer, criticalOutageLayer, managedOutageLayer, bothOutageLayer, countyLayer, zipLayer, wardsLayer, bothTFLayer, criticalTF];
var _default = layers;
exports.default = _default;